import {allApis} from '../../api/index'

const fn = {
  install (Vue, options) {
    Vue.prototype.$ajax = allApis
    Vue.prototype.$getDistance = function getDistance (p1, p2) {
      var R = 6378137
      var dLat = (p2.lat - p1.lat) * Math.PI / 180
      var dLng = (p2.lng - p1.lng) * Math.PI / 180
      dLat = Math.abs(dLat)
      dLng = Math.abs(dLng)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(p1.lat * Math.PI / 180) *
        Math.cos(p2.lat * Math.PI / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return Math.round(d)
    }
    Vue.prototype.$getList = function getList (arr, point) {
      arr.map((v, i) => {
        var p = {lat: v.lat, lng: v.lng}
        this.$set(
          arr[i],
          'distance',
          (this.$getDistance(point, p) / 1000).toFixed(2) + 'km'
        )
      })
    }
    Vue.prototype.$face = function face ($event) {
      var value = $event.target.value
      var regRule = /([\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF])|(\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6])|(\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0])/g
      if (!!value.match(regRule)) {
        $event.target.value = value.replace(regRule, '')
      }
      return $event.target.value
    }
    //拷贝
    Vue.prototype.$copy = function (target, source) {
      for (var obj in source) {
        target[obj] = source[obj]
      }
      return target
    }
    //格式化日期
    Vue.prototype.$formatDate = function (date = new Date(), format = 'yyyy-MM-dd') {
      var o = {
        'M+': date.getMonth() + 1, //month
        'd+': date.getDate(),    //day
        'h+': date.getHours(),   //hour
        'm+': date.getMinutes(), //minute
        's+': date.getSeconds(), //second
        'q+': Math.floor((date.getMonth() + 3) / 3),  //quarter
        'S': date.getMilliseconds() //millisecond
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1,
            RegExp.$1.length == 1 ? o[k] :
              ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return format
    }
    //增加日志
    Vue.prototype.$addLog = function (FunctionID = '', ItemID = '', ActionID = '', Comments = '', _this = this) {
      _this.$ajax
        .AddSysLog({
          type: 'post',
          data: {
            functionID: FunctionID,
            ItemID: ItemID,
            actionID: ActionID,
            operator: localStorage.UserName || localStorage.LogonName,
            LogTime: _this.$formatDate(),
            Comments: Comments
          }
        })
    }
    // 字体尺寸适配屏幕分辨率
    Vue.prototype.$judgeFontSize = function () {
      let screenWidth = window.screen.width
      if (this.screenWidth == 1920) {
        this.fontSize.smFont = true // 高分辨率启用小号字体
        this.fontSize.mdFont = false // 低分辨率启用中号字体
      }
      if (this.screenWidth == 1366) {
        this.fontSize.mdFont = true
        this.fontSize.smFont = false
      }
    }
    // 日期选择框清空，数据处理
    Vue.prototype.$dateNull = function (date) {
      let begT = ''
      let endT = ''
      if (date != null && date != '') {
        begT = date[0]
        endT = date[1]
      }

      return [begT, endT]
    }
    // 日期数据截取
    Vue.prototype.$dateSlice = function (date) {
      if (date != '' && date != null) {
        return date.slice(0, 10)
      }
      ;
      return date;
    }
  }
}

export default fn;



// WEBPACK FOOTER //
// ./src/page/util/fn.js